import PSPDFKit from "pspdfkit";
const blobToBase64 = blob => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
        reader.onloadend = () => {
            resolve(reader.result);
        };
    });
};


const editorToolbarItems = defaultDocumentEditorToolbarItems =>
    defaultDocumentEditorToolbarItems.filter(
        (item) =>
            // item.type === "add" ||
            item.type === "remove" ||
            item.type === "duplicate"
    );

function getPageVisibleRect(instance) {
    const pageIndex = instance.viewState.currentPageIndex;
    // Page DOM element
    const pageEl = instance.contentDocument.querySelector(
        `.PSPDFKit-Page[data-page-index="${pageIndex}"]`
    );
    const pageBoundingClientRect = pageEl.getBoundingClientRect();
    // Viewport DOM element
    const viewportEl =
        instance.contentDocument.querySelector(".PSPDFKit-Viewport");
    // Toolbar DOM element, needs offsetting
    const toolbarEl =
        instance.contentDocument.querySelector(".PSPDFKit-Toolbar");
    // Get visible page area in page units
    return instance.transformContentClientToPageSpace(
        new PSPDFKit.Geometry.Rect({
            left: Math.max(pageBoundingClientRect.left, 0),
            top: Math.max(pageBoundingClientRect.top, toolbarEl.scrollHeight),
            width: Math.min(pageEl.clientWidth, viewportEl.clientWidth),
            height: Math.min(pageEl.clientHeight, viewportEl.clientHeight),
        }),
        pageIndex
    );
}


async function exportSelectedImageAsImage(instance, image) {
  if (!instance || !image) return null;

  const blob = await instance.exportAttachment(image.imageAttachmentId);
  const base64 = await blobToBase64(blob);
  return { blob, base64 };
}
function normalizeStrokeColor(color) {
  if (!color || typeof color.get !== "function") return "#000000";
  const r = color.get("r") ?? 0;
  const g = color.get("g") ?? 0;
  const b = color.get("b") ?? 0;
  const a = color.get("alpha") ?? 1;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

async function exportSelectedInkAsImage(ink) {
  if (!ink) return null;

  const { boundingBox, lines, strokeColor, lineWidth } = ink;
  const padding = 10;

  const width = Math.ceil(boundingBox.width + padding * 2);
  const height = Math.ceil(boundingBox.height + padding * 2);

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");
  ctx.lineWidth = lineWidth;
  ctx.strokeStyle = normalizeStrokeColor(strokeColor);
  ctx.lineCap = "round";
  ctx.lineJoin = "round";

  const jsLines = lines.toArray();

  const offsetX = -(boundingBox.left ?? boundingBox.x ?? 0) + padding;
  const offsetY = -(boundingBox.top ?? boundingBox.y ?? 0) + padding;

  jsLines.forEach((line, lineIndex) => {
    // 🔄 수정 포인트: line 자체가 List<Point>
    const points = line.toArray?.() || [];

    console.log(`🖊️ Line ${lineIndex + 1}: ${points.length} points`);

    if (points.length === 0) return;

    ctx.beginPath();

    const first = points[0];
    const firstX = first.x + offsetX;
    const firstY = first.y + offsetY;

    ctx.moveTo(firstX, firstY);

    for (let i = 1; i < points.length; i++) {
      const pt = points[i];
      const adjX = pt.x + offsetX;
      const adjY = pt.y + offsetY;
      ctx.lineTo(adjX, adjY);
    }

    ctx.stroke();
  });

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  const base64 = await blobToBase64(blob);

  return { blob, base64 };
}




export { blobToBase64, editorToolbarItems, getPageVisibleRect,exportSelectedImageAsImage, exportSelectedInkAsImage}
